import { doc, setDoc } from 'firebase/firestore';
import { IWeightReportSettings } from '../../../providers/settings/reports/weightReportSettingsProvider';
import { userAsPromise } from '../../../providers/userProvider';

/**
 * @description updates weight report settings
 * @param metric
 * @returns Promise
 */
export const updateWeightSettings = async (
  settings: IWeightReportSettings
): Promise<void> => {
  const user = await userAsPromise();

  return setDoc(
    doc(
      user.services.firestore,
      `userProfiles/${user.id}/settings/weightReport`
    ),
    settings,
    { merge: true }
  );
};
